/**
 * 全局指令注册
 */

import hasPermi from './hasPermi'

export default {
  install(app) {
    app.directive('hasPermi', hasPermi)
  }
}
